import { memo } from "react";
import AdditionalDetails from "./AdditionalDetails";
import OrderHistory from "./OrderHistory";
import { BzTabs, BzTab, BzTabsContainer, BzTabsContent, BzButton } from "../../../../../components";
import { Col, Container, Row } from "react-bootstrap";

const Sip = ({ orderHistory, fundDetails }) => {
    const sipInstructionTabs = [
        {
            id: 1,
            name: "Order History",
            tabKey: 'order_history',
            tabContent: <OrderHistory orderHistory={orderHistory} />,
        },
        {
            id: 2,
            name: "Additional Details",
            tabKey: 'additional_details',
            tabContent: <AdditionalDetails fundDetails={fundDetails} />
        },
    ];
    return (
        <Container fluid className='p-0'>
            <Row className='g-0'>
                <Col md={5} className='mrgauto p-3'>
                    <Row className='g-0 my-3'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='horizontal-scroll-wrap d-flex'>
                                <BzTabs className='nav nav-tabs'>
                                    {
                                        sipInstructionTabs.map((cornerType) => (
                                            <BzTab key={cornerType?.id} isActive={cornerType.tabKey === 'order_history'} tabKey={cornerType.tabKey} tabContent={cornerType.tabContent} className='nav-link text-capitalize'>
                                                {cornerType?.name}
                                            </BzTab>
                                        ))
                                    }
                                </BzTabs>
                            </div>
                        </Col>
                        <Col className='d-flex justify-content-end align-items-center'>
                            <BzButton className='btn btn-sm btn-outline text-capitalize ms-3'>STOP</BzButton>
                            <BzButton className='btn btn-sm btn-primary text-capitalize ms-3'>PAUSE</BzButton>
                        </Col>
                    </Row>
                    <Row className='g-0'>
                        <Col>
                            <BzTabsContainer>
                                {sipInstructionTabs.map((each) =>
                                    <BzTabsContent key={each.id} showDefault={each.tabKey === "order_history"} isActive={each.tabKey === "order_history"} tabKey={each.tabKey}>
                                        {each.tabContent}
                                    </BzTabsContent>
                                )
                                }
                            </BzTabsContainer>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );

};
export default memo(Sip);